import config from './config';

export const isValidFileSignature = (file: File): Promise<boolean> => {
  return new Promise((resolve, reject) => {
    if (file.type === 'image/svg+xml') {
      try {
        file.arrayBuffer().then((resp) => {
          const ui8 = new Uint8Array(resp);
          const fileContent = new TextDecoder('utf-8').decode(ui8);
          const parser = new DOMParser();
          parser.parseFromString(fileContent, 'image/svg+xml');
          resolve(true);
        });
      } catch (ex) {
        resolve(false);
      }
    } else {
      const reader = new FileReader();
      const blob = file.slice(0, 4);
      reader.readAsArrayBuffer(blob);

      reader.onloadend = () => {
        const fileBytes = reader.result as ArrayBuffer;
        const fileSignature = getSignature(fileBytes);

        return resolve(isValidSignature(fileSignature));
      };

      reader.onerror = (error) => reject(error);
    }
  });
};

export const isValidAttachmentExtension = (fileName: string): boolean => {
  return isValidFileExtension(fileName, config.supportedAttachmentsFileExt);
};

export const isValidImageExtension = (fileName: string): boolean => {
  return isValidFileExtension(fileName, config.supportedImageFileExt);
};

const isValidFileExtension = (
  fileName: string,
  allowedExtensions: []
): boolean => {
  const fileExtension = getExtension(fileName);
  let isValidExtension = false;
  allowedExtensions.forEach((ext) => {
    if (fileExtension === ext) {
      isValidExtension = true;
    }
  });
  return isValidExtension;
};

const getExtension = (filename: string) => {
  const parts = filename.split('.');
  return parts[parts.length - 1];
};

const getSignature = (fileResult: ArrayBuffer) => {
  const uint = new Uint8Array(fileResult);
  const bytes: string[] = [];
  uint.forEach((byte) => {
    bytes.push(byte.toString(16));
  });
  return bytes.join('').toUpperCase();
};

const isValidSignature = (signature: string): boolean => {
  switch (signature) {
    case '89504E47': //'image/png'
    case '47494638': //'image/gif'
    case '25504446': //'application/pdf'
    case 'FFD8FFDB': //'image/jpeg'
    case 'FFD8FFE0': //'image/jpeg'
    case 'FFD8FFE1': //'image/jpeg'
    case '504B34': // new office docx, pptx, xlsx
    case '504B0304': // new office docx, pptx, xlsx
    case 'D0CF11E0': // old office doc, ppt, xls
      return true;
    default:
      return false;
  }
};
